import { Record, Union } from "../fable-library-js.4.19.3/Types.js";
import { option_type, bool_type, record_type, string_type, int32_type, class_type, union_type } from "../fable-library-js.4.19.3/Reflection.js";
import { printf, toText } from "../fable-library-js.4.19.3/String.js";
import { compare } from "../fable-library-js.4.19.3/Date.js";
import { totalSeconds } from "../fable-library-js.4.19.3/TimeSpan.js";
import { addSeconds, op_Subtraction } from "../fable-library-js.4.19.3/DateOffset.js";
import { newGuid } from "../fable-library-js.4.19.3/Guid.js";

export class MfaChallengeStatus extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Active", "Expired", "Locked"];
    }
}

export function MfaChallengeStatus_$reflection() {
    return union_type("Webbler.Models.MfaChallenge.MfaChallengeStatus", [], MfaChallengeStatus, () => [[], [], []]);
}

export function MfaChallengeStatus_get_describe() {
    return (_arg) => ((_arg.tag === 1) ? "Expired" : ((_arg.tag === 2) ? "Locked" : "Active"));
}

export function MfaChallengeStatus_get_parse() {
    return (_arg) => {
        switch (_arg) {
            case "Active":
                return new MfaChallengeStatus(0, []);
            case "Expired":
                return new MfaChallengeStatus(1, []);
            case "Locked":
                return new MfaChallengeStatus(2, []);
            default:
                throw new Error("Invalid MfaChallengeStatus string");
        }
    };
}

export class MfaChallengeResponse extends Record {
    constructor(ChallengeId, ExpiresInSeconds, CooldownSeconds, PendingToken) {
        super();
        this.ChallengeId = ChallengeId;
        this.ExpiresInSeconds = (ExpiresInSeconds | 0);
        this.CooldownSeconds = (CooldownSeconds | 0);
        this.PendingToken = PendingToken;
    }
}

export function MfaChallengeResponse_$reflection() {
    return record_type("Webbler.Models.MfaChallenge.MfaChallengeResponse", [], MfaChallengeResponse, () => [["ChallengeId", class_type("System.Guid")], ["ExpiresInSeconds", int32_type], ["CooldownSeconds", int32_type], ["PendingToken", string_type]]);
}

export class MfaVerifyRequest extends Record {
    constructor(ChallengeId, Code) {
        super();
        this.ChallengeId = ChallengeId;
        this.Code = Code;
    }
}

export function MfaVerifyRequest_$reflection() {
    return record_type("Webbler.Models.MfaChallenge.MfaVerifyRequest", [], MfaVerifyRequest, () => [["ChallengeId", class_type("System.Guid")], ["Code", string_type]]);
}

export class MfaChallengeError extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["GenericMfaError", "ExnError", "ActiveChallengeExists", "InvalidCode", "Expired", "TooManyAttempts", "ChallengeNotFound", "AlreadyConsumed"];
    }
}

export function MfaChallengeError_$reflection() {
    return union_type("Webbler.Models.MfaChallenge.MfaChallengeError", [], MfaChallengeError, () => [[], [["Item", class_type("System.Exception")]], [], [], [], [], [], []]);
}

export function MfaChallengeError_get_describe() {
    return (_arg) => ((_arg.tag === 1) ? toText(printf("An exception has occurred %O"))(_arg.fields[0]) : ((_arg.tag === 3) ? "The code you entered is invalid. Please try again." : ((_arg.tag === 2) ? "An active MFA challenge already exists for this user." : ((_arg.tag === 4) ? "This code has expired. Please request a new one." : ((_arg.tag === 5) ? "Too many failed attempts. Please try logging in again" : ((_arg.tag === 6) ? "MFA challenge not found." : ((_arg.tag === 7) ? "This code has already been used." : "An error has occurred")))))));
}

export class MfaVerifyResponse extends Record {
    constructor(jwtToken) {
        super();
        this.jwtToken = jwtToken;
    }
}

export function MfaVerifyResponse_$reflection() {
    return record_type("Webbler.Models.MfaChallenge.MfaVerifyResponse", [], MfaVerifyResponse, () => [["jwtToken", string_type]]);
}

export class MfaResendRequest extends Record {
    constructor(ChallengeId) {
        super();
        this.ChallengeId = ChallengeId;
    }
}

export function MfaResendRequest_$reflection() {
    return record_type("Webbler.Models.MfaChallenge.MfaResendRequest", [], MfaResendRequest, () => [["ChallengeId", class_type("System.Guid")]]);
}

export class MfaResendResponse extends Record {
    constructor(Sent, CooldownSeconds, ExpiresAt) {
        super();
        this.Sent = Sent;
        this.CooldownSeconds = CooldownSeconds;
        this.ExpiresAt = ExpiresAt;
    }
}

export function MfaResendResponse_$reflection() {
    return record_type("Webbler.Models.MfaChallenge.MfaResendResponse", [], MfaResendResponse, () => [["Sent", bool_type], ["CooldownSeconds", option_type(int32_type)], ["ExpiresAt", option_type(class_type("System.DateTimeOffset"))]]);
}

export class MfaChallenge extends Record {
    constructor(Id, UserId, MfaCode, CreatedAt, ExpiresAt, LastSentAt, ResendCount, VerifyAttemptCount, Status) {
        super();
        this.Id = Id;
        this.UserId = UserId;
        this.MfaCode = MfaCode;
        this.CreatedAt = CreatedAt;
        this.ExpiresAt = ExpiresAt;
        this.LastSentAt = LastSentAt;
        this.ResendCount = (ResendCount | 0);
        this.VerifyAttemptCount = (VerifyAttemptCount | 0);
        this.Status = Status;
    }
}

export function MfaChallenge_$reflection() {
    return record_type("Webbler.Models.MfaChallenge.MfaChallenge", [], MfaChallenge, () => [["Id", class_type("System.Guid")], ["UserId", class_type("System.Guid")], ["MfaCode", string_type], ["CreatedAt", class_type("System.DateTimeOffset")], ["ExpiresAt", class_type("System.DateTimeOffset")], ["LastSentAt", class_type("System.DateTimeOffset")], ["ResendCount", int32_type], ["VerifyAttemptCount", int32_type], ["Status", MfaChallengeStatus_$reflection()]]);
}

/**
 * Check if the challenge has expired
 */
export function MfaChallenge__IsExpired_Z53C0511E(this$, now) {
    return compare(now, this$.ExpiresAt) > 0;
}

/**
 * Check if enough time has passed since last code send (for cooldown)
 */
export function MfaChallenge__CanResend_Z6677D282(this$, now, cooldownSeconds) {
    return totalSeconds(op_Subtraction(now, this$.LastSentAt)) >= cooldownSeconds;
}

/**
 * Check if the maximum number of resends has been exceeded
 */
export function MfaChallenge__HasExceededMaxResends_Z524259A4(this$, maxResends) {
    return this$.ResendCount >= maxResends;
}

/**
 * Check if the maximum number of verify attempts has been exceeded
 */
export function MfaChallenge__HasExceededMaxVerifyAttempts_Z524259A4(this$, maxVerifyAttempts) {
    return this$.VerifyAttemptCount >= maxVerifyAttempts;
}

/**
 * Generate a new MFA code
 */
export function MfaChallenge_create_Z46557E0C(userId, code, now, validDurationSeconds) {
    const expiresAt = addSeconds(now, validDurationSeconds);
    return new MfaChallenge(newGuid(), userId, code, now, expiresAt, now, 0, 0, new MfaChallengeStatus(0, []));
}

